import { getCookie, isProdEnv } from '@vfde-sails/utils';
import { ProductType } from '../enums/product';
import { BasketPath, Cookies, Domains, LandingPagePath, QueryNames } from '../enums/network';
import { getCMSConfig } from './cms';
import { QueryParams } from '../interfaces/network';
import { JarvisVendorType } from '@vfde-sails/avc-core';

export const getQueryString = (data: QueryParams = {}, filterFalsy = true): string => {
    const params = new URLSearchParams();

    for (const [key, value] of Object.entries(data)) {
        if ((filterFalsy && !value) || null === value || 'undefined' === typeof value) {
            continue;
        }

        params.set(key, value.toString() || '');
    }

    return params.toString() ? `?${params}` : '';
};

export const getUrl = (
    domain: string | URL,
    endpoint: string,
    query?: QueryParams,
    filterFalsyQuery = true
): string => {
    const urlString = isProdEnv() ? domain : '';
    const queryString = getQueryString(query, filterFalsyQuery);

    return `${urlString}${endpoint}${queryString}`;
};

/**
 * Updates the page url with the chosen tariffId
 * @param tariffId Tariff id chosen
 */
export const updatePageUrl = (tariffId?: string) => {
    if (!tariffId) { return; }

    const url = new URL(window.location.href);

    // Do not set query param in case of default selection
    if (tariffId !== getCMSConfig().selected.tariffId) {
        url.searchParams.set(QueryNames.TARIFF, tariffId);
    } else {
        url.searchParams.delete(QueryNames.TARIFF);
    }

    history.replaceState(null, '', url.toString());
};

/**
 * Constructs a url to the option page
 * @param metacode Metacode of the chosen product
 * @returns A string containg the url
 */
export const getOptionPageUrl = (metacode: string) => {
    const queryParams: QueryParams = {
        [QueryNames.BASKET]: metacode,
        [QueryNames.FF]: getCookie(Cookies.FF),
    };

    return getUrl(Domains.ZUHAUSEPLUS, BasketPath.OPTION, queryParams);
};

export const getProductPageUrl = (productType: JarvisVendorType, metacode: string) => {
    const queryParams: QueryParams = {
        [QueryNames.TARIFF]: metacode,
        [QueryNames.FF]: getCookie(Cookies.FF),
    };

    switch (productType) {
        case ProductType.FIBER:
            return getUrl(Domains.VF, LandingPagePath.FIBER, queryParams);
        case ProductType.CABLE:
            return getUrl(Domains.VF, LandingPagePath.CABLE, queryParams);
        case ProductType.DSL:
            return getUrl(Domains.VF, LandingPagePath.DSL, queryParams);
        default:
            return getUrl(Domains.VF, LandingPagePath.GIGACUBE);
    }
};

/**
 *
 * @returns True if the current environment is ST
 */
export const isSTEnv = () => window.location.origin === Domains.ST;
